import { render, staticRenderFns } from "./comperpsku.vue?vue&type=template&id=0c737cb6"
import script from "./comperpsku.vue?vue&type=script&lang=js"
export * from "./comperpsku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports